import request from "axios";
import types, { MINIMUM_WAIT_FOR_RESPONSE, WAIT_TO_SHOW_CONTENT } from "./types";

import { nextPage as nextPaginationPage, getPage } from "data/pagination";

export const initialFetch = () => ({
  type: types.INITIAL_FETCH,
});

export const resetCampaigns = () => {
  return {
    type: types.RESET_CAMPAIGNS,
  };
};

export const setError = (error) => ({
  type: types.SET_ERROR,
  error,
});

export const receivedCampaigns = (campaigns, total) => {
  return {
    type: types.RECEIVED_CAMPAIGNS,
    campaigns,
    total,
  };
};

export const resetAndAddNewCampaigns = (campaigns, total) => {
  return {
    type: types.RESET_AND_ADD_NEW_CAMPAIGNS,
    campaigns,
    total,
  };
};

export function buildUrl(options) {
  let buildableUrl = `/microsite/api/campaigns?`;

  if (options.sectionId) {
    buildableUrl += `&section_id=${options.sectionId}`;
  }

  if (options.campaignId) {
    buildableUrl += `&campaign_id=${options.campaignId}`;
  }

  if (options.page && options.page >= 0) {
    buildableUrl += `&page=${options.page}`;
  }

  if (options.query) {
    buildableUrl += `&search=${options.query}`;
  }

  if (options.parentQuery) {
    buildableUrl += `&search=${options.parentQuery}`;
  }

  if (options.limit) {
    buildableUrl += `&limit=${options.limit}`;
  }

  if (options.category) {
    if (options.category !== "null" && options.category != "") {
      buildableUrl += `&category=${encodeURIComponent(options.category)}`;
    }
  }

  return buildableUrl;
}

// Currently this is for short polling campaign stats
// In future, this can be refactored to be appropriately used to store
// live updated states in redux.
export const fetchCampaignStats = (campaignId, donorMetric = "") => {
  let campaignStatsURL = `/microsite/api/campaigns/stats?ids[]=${campaignId}&donor_metric=${donorMetric}`;
  return request(campaignStatsURL).then((res) => {
    return res.data;
  });
};

export const fetchCampaigns = (options = {}) => {
  return (dispatch, getState) => {
    const { nextPage } = options;

    if (nextPage) {
      options.page = getPage()(getState()) + 1;
      dispatch(nextPaginationPage());
    }

    const buildableUrl = buildUrl(options);

    const startTime = Date.now();

    return request(buildableUrl)
      .then((res) => {
        // dispatch actions after set timeout so the campaigns don't show
        // in the ui before the spinner is canceled
        const dispatchReceivedCampaigns = () => {
          if (options.resetCampaigns === true) {
            dispatch(
              resetAndAddNewCampaigns(res.data.campaigns, res.data.meta.total_campaigns),
            );
          } else {
            dispatch(receivedCampaigns(res.data.campaigns));
          }
        };

        const endTime = Date.now();

        // toggle is loading to false if we have waited a long enough time
        // to make the ui more fluid
        if (endTime - startTime < MINIMUM_WAIT_FOR_RESPONSE) {
          const promise = new Promise((resolve) => {
            setTimeout(() => {
              dispatchReceivedCampaigns();
              resolve({
                total: res.data.meta.total_campaigns,
              });
            }, WAIT_TO_SHOW_CONTENT);
          });

          return promise.then((res) => res);
        } else {
          dispatchReceivedCampaigns();

          return {
            total: res.data.meta.total_campaigns,
          };
        }
      })
      .catch((err) => {
        dispatch(setError(err));
        throw err;
      });
  };
};
